(function($){
   $(function() {
      
      /*-------------------
      繝ｪ繧ｹ繝医�隱ｭ縺ｿ霎ｼ縺ｿ
      <div class="item-list-loader" data-url="隱ｭ縺ｿ霎ｼ縺ｿurl" data-counts="隱ｭ縺ｿ霎ｼ縺ｿ莉ｶ謨ｰ" data-mode="shuffle"></div>
      --------------------*/
      $('.item-list-loader').each(function(){
         
         var $self = $(this);
         
         //data-url縺後≠繧句�ｴ蜷医�縺ｿ
         if($self.attr('data-url') != ""){
            
            var cc = "&";
            if($self.attr('data-url').split("?").length < 2) cc = "?";
            
            var shuffle = false;
            if($(this).attr('data-mode') == "shuffle") shuffle = true;
            
            var url = $self.attr('data-url') + cc + "list-view-limit=" + $self.attr('data-counts');
            
            $.ajax({
               url: url,
               dataType:"html",
               cache: true,
               beforeSend:function(){
                  //繝ｪ繧ｯ繧ｨ繧ｹ繝�
                  //蜑阪Ο繝ｼ繝�ぅ繝ｳ繧ｰ陦ｨ遉ｺ
                  /* 
                  $(btn).text("隱ｭ縺ｿ霎ｼ縺ｿ荳ｭ");
                  
                  interval = setInterval(function(){  
                     //$(control_loading).animate({opacity:"toggle"},1000);  
                  }, 1000);
                  */
               },
               success: function(html){

                  //item驛ｨ蛻��縺ｿ繧呈歓蜃ｺ縺励※謖ｿ蜈･
                  var $items = $('#item-list-area .item-list-container',html);
                  var items = "";
                  
                  if(shuffle){

                     var tmp = [];
                     
                     $('.item',$items).each(function(){
                        tmp.push($('<div>').append($(this).clone()).html());
                     });
                     
                     tmp.sort(function(){
                        return Math.random() - Math.random();
                     });
                     
                     tmpHtml = "";
                     for(i = 0; i < tmp.length; i++){
                        tmpHtml += tmp[i] + " ";
                     }
                     
                     items = tmpHtml;
                  
                  } else {

                     items = $items.html()
                     
                  }

  
                  $self.prepend(items);
                  
                  //蜷�ｨｮ繝ｭ繝ｼ繝牙�逅�
                  $('.thumb',$self).css({'height':'auto'});
                  $("img.lazy",$self).css({'height':'auto'}).lazyload({
                     threshold : 2000,
                     effect: 'fadeIn'
                  });
                  
               }
            });
            
         }
      });
      
   });
})(jQuery);